import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { AlertCircle } from "lucide-react";

export const ClientCompany = ({ formData, setFormData }: { formData: any, setFormData: any }) => {
    return (
        <Card className="border border-gray-100/80 shadow-sm bg-white">
            <CardHeader className="pb-3 bg-gray-50/50 border-b border-gray-100">
                <CardTitle className="text-base font-bold text-gray-900">Datos Corporativos</CardTitle>
                <p className="text-xs text-gray-400">Información legal y fiscal de la persona jurídica</p>
            </CardHeader>
            <CardContent className="space-y-6 pt-6">
                {!formData.esEmpresa ? (
                    <div className="flex items-start gap-3 bg-amber-50 border border-amber-100 rounded-xl p-4 text-amber-800 text-xs">
                        <AlertCircle className="h-4.5 w-4.5 text-amber-600 shrink-0 mt-0.5" />
                        <div>
                            <p className="font-bold mb-0.5">El cliente no está registrado como empresa</p>
                            <p className="text-gray-600">Para poder editar y asociar una Razón Social corporativa, primero debes marcar la opción "Es empresa" o seleccionar "Persona Jurídica" en la pestaña de Información General.</p>
                        </div>
                    </div>
                ) : null}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                        <Label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Razón Social</Label>
                        <Input 
                            className="rounded-xl bg-white" 
                            placeholder="Ej. Alcaldía Mayor de Bogotá, Nudier S.A.S." 
                            value={formData.razonSocial || ""}
                            onChange={e => setFormData({ ...formData, razonSocial: e.target.value })}
                            disabled={!formData.esEmpresa}
                        />
                    </div>
                    <div className="space-y-2">
                        <Label className="text-xs font-bold text-gray-500 uppercase tracking-wider">NIT / Identificación Fiscal</Label>
                        <Input 
                            className="rounded-xl bg-white" 
                            placeholder="Ej. 800.123.456-1" 
                            value={formData.nit || ""}
                            onChange={e => setFormData({ ...formData, nit: e.target.value })}
                            disabled={!formData.esEmpresa}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
